<template>
    <div v-if="reason==='role-permission'" class="prohibited-group">
      <p class="prohibited-text">You do not have permission to access this page.</p>
      <button @click="goToDashboard" class="dashboard-link">Back to home</button>
    </div>
    <div v-else-if="reason==='organization-permission'" class="prohibited-group">
      <p class="prohibited-text">You do not have permission to access this organization.</p>
      <button @click="handleLogout" class="dashboard-link">Logout</button>
    </div>
    <div v-else-if="reason==='is-migrated'" class="prohibited-group">
      <p class="prohibited-text">Your organization has been migrated to Nova Dashboard.</p>
      <button @click="gotoNovaDashboard" class="dashboard-link">Open Nova Dashboard</button>
    </div>
  </template>
  
  <script>
    import { mapGetters } from "vuex";

    export default {
      computed: {
        ...mapGetters({
          organizationId: "organization/currentOrganizationId"
        }),
        reason() {
          return this.$route.query.reason;
        }
      },
      methods: {
        goToDashboard() {
          const organizationId = this.organizationId || this.$route.query.organizationId;
          if (organizationId) {
            this.$router.push({
              name: "dashboard",
              params: { organizationId }
            });
          } else {
            // fallback: go to home or show error
            this.$router.push("/");
          }
        },
        gotoNovaDashboard() {
          window.open(process.env.VUE_APP_NOVA_DASHBOARD_URL || "#", "_blank");
        },
        handleLogout() {
          this.$store.dispatch("auth/logout").then(() => {
            this.$router.push({ name: "Login" });
          });
        }
      }
    }
  </script>
  <style lang="scss" scoped>
  .prohibited-group {
    margin: auto;
    text-align: center;
    margin-top: 250px;
    margin-bottom: 300px;
    .prohibited-text {
      max-width: 350px;
      font-size: 18px;
      line-height: 26px;
    }
    .dashboard-link {
      font-size: 18px;
      background: none;
      border: none;
      color: #007bff;
      cursor: pointer;
      text-decoration: underline;
      padding: 0;
    }
  }
  </style>
  